<template>
	<div class="gallery" :style="cssVars">
		<div class="container">
			<div class="left">
				<div class="top">
					<h2 v-html="parsedData.title"></h2>
				</div>
				<div class="bottom" v-if="window.width >= 1024">
					<div class="nav">
						<carousel-arrow
							class="swiper-button-prev swiper-button-prv"
							:class="'swiper-button-prev-' + section_id"
							direction="prev"
							theme="dark"
						></carousel-arrow>
						<carousel-arrow
							class="swiper-button-next swiper-button-nxt"
							:class="'swiper-button-next-' + section_id"
							direction="next"
							theme="dark"
						></carousel-arrow>
					</div>

					<div class="swiper swiper-text" :class="section_id + '_text'">
						<div class="swiper-wrapper swiper-wrapper-text">
							<div
								class="swiper-slide"
								v-for="(slide, index) in parsedData.gallery"
								:key="index"
							>
								<h3 v-html="slide.title"></h3>
								<p v-html="slide.description"></p>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="right">
				<div class="swiper swiper-main" :class="section_id + '_main'">
					<div class="swiper-wrapper">
						<div
							class="swiper-slide"
							v-for="(slide, index) in parsedData.gallery"
							:key="index"
						>
							<img :src="slide.url" />
						</div>
					</div>
				</div>

				<div class="bottom" v-if="window.width < 1024">
					<div class="nav">
						<carousel-arrow
							class="swiper-button-prev swiper-button-prv"
							:class="'swiper-button-prev-' + section_id"
							direction="prev"
							theme="dark"
						></carousel-arrow>
						<carousel-arrow
							class="swiper-button-next swiper-button-nxt"
							:class="'swiper-button-next-' + section_id"
							direction="next"
							theme="dark"
						></carousel-arrow>
					</div>

					<div class="swiper swiper-text" :class="section_id + '_text'">
						<div class="swiper-wrapper swiper-wrapper-text">
							<div
								class="swiper-slide"
								v-for="(slide, index) in parsedData.gallery"
								:key="index"
							>
								<h3 v-html="slide.title"></h3>
								<p v-html="slide.description"></p>
							</div>
						</div>
					</div>
				</div>

				<div
					thumbsSlider=""
					class="swiper swiper-thumb"
					:class="section_id + '_thumb'"
				>
					<div class="swiper-wrapper">
						<div
							class="swiper-slide"
							v-for="(slide, index) in parsedData.gallery"
							:key="index"
						>
							<img :src="slide.url" />
						</div>
					</div>
				</div>

				<div
					class="swiper-pagination"
					:class="'swiper-pag-' + section_id"
					v-if="parsedData.gallery.length > 2"
				></div>
			</div>
		</div>
	</div>
</template>

<script>
import CarouselArrow from '../vue/CarouselArrow.vue';
import Swiper from 'swiper';

export default {
	data() {
		return {
			window: {
				width: 0,
				height: 0,
			},
			swiper: null,
			swiper2: null,
			swiper3: null,
		};
	},

	props: {
		title: {
			default: 'Basic Page Links (with description)',
		},
		cta: {},
		image_gallery: {},
		type: {},
		section_id: {
			default: 'da_gallery',
		},
		no_slider: {
			default: 'false',
		},
		data: {},
	},

	computed: {
		parsedData() {
			if (this.data) {
				return JSON.parse(this.data);
			} else {
				return null;
			}
		},

		cssVars() {
			return {
				'--padding-top': this.parsedData.padding_top
					? this.parsedData.padding_top + 'px'
					: '80px',
				'--padding-bottom': this.parsedData.padding_bottom
					? this.parsedData.padding_bottom + 'px'
					: '80px',
				'--padding-top-mobile': this.parsedData.padding_top_mobile
					? this.parsedData.padding_top_mobile + 'px'
					: '40px',
				'--padding-bottom-mobile': this.parsedData.padding_bottom_mobile
					? this.parsedData.padding_bottom_mobile + 'px'
					: '40px',
				'--text-colour': this.parsedData.text_colour
					? this.parsedData.text_colour
					: false,
				'--background-colour': this.parsedData.background_colour
					? this.parsedData.background_colour
					: false,
			};
		},
	},

	watch: {},

	methods: {
		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
			this.initSliders();
		},

		initSliders() {
			// eslint-disable-next-line no-unused-vars
			var swiper = new Swiper('.' + this.section_id + '_thumb', {
				spaceBetween: 24,
				slidesPerView: 4,
				// freeMode: true,
				// centeredSlides: false,
				// grabCursor: true,
				breakpoints: {
					400: {
						slidesPerView: 2.2,
						spaceBetween: 24,
						centeredSlides: false,
					},
					1024: {
						slidesPerView: 2.2,
						spaceBetween: 24,
					},
					1240: {
						slidesPerView: 4,
						spaceBetween: 24,
					},
					1490: {
						slidesPerView: 4,
						spaceBetween: 24,
					},
					1920: {
						slidesPerView: 4,
						spaceBetween: 24,
					},
				},
				watchSlidesVisibility: true,
				watchSlidesProgress: true,
				pagination: {
					el: '.swiper-pag-' + this.section_id,
					clickable: true,
				},
				navigation: {
					nextEl: '.swiper-button-next-' + this.section_id,
					prevEl: '.swiper-button-prev-' + this.section_id,
				},
				hashNavigation: {
					watchState: true,
				},
			});

			// eslint-disable-next-line no-unused-vars
			var swiper2 = new Swiper('.' + this.section_id + '_main', {
				spaceBetween: 24,
				slidesPerView: 1,
				watchSlidesVisibility: true,
				watchSlidesProgress: true,
				navigation: {
					nextEl: '.swiper-button-next-' + this.section_id,
					prevEl: '.swiper-button-prev-' + this.section_id,
				},
				hashNavigation: {
					watchState: true,
				},
				thumbs: {
					// clickable: true,
					swiper: swiper,
				},
			});

			// eslint-disable-next-line no-unused-vars
			var swiper3 = new Swiper('.' + this.section_id + '_text', {
				spaceBetween: 24,
				slidesPerView: 1,
				watchSlidesVisibility: true,
				watchSlidesProgress: true,
				effect: 'fade',
				navigation: {
					nextEl: '.swiper-button-next-' + this.section_id,
					prevEl: '.swiper-button-prev-' + this.section_id,
				},
				hashNavigation: {
					watchState: true,
				},
				thumbs: {
					// clickable: true,
					swiper: swiper,
				},
			});
		},
	},

	components: {
		// SecondaryButton,
		CarouselArrow,
	},

	created() {
		window.addEventListener('resize', this.handleResize);
		window.addEventListener('load', this.handleResize);
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},

	destroyed() {
		window.removeEventListener('resize', this.handleResize);
		this.handleResize();
	},

	mounted() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},

	change() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.gallery {
	padding: var(--padding-top) 0 var(--padding-bottom);
	position: relative;
	background: white;

	@media (max-width: $mobile-xl) {
		padding: var(--padding-top-mobile) 0 var(--padding-bottom-mobile);
		overflow: hidden;
	}

	&::after {
		content: '';
		position: absolute;
		left: 0;
		top: 250px;
		height: calc(100% - 250px);
		width: 100%;
		background-color: var(--background-colour);
		z-index: 0;

		@media (max-width: $mobile-xl) {
			top: 150px;
			height: calc(100% - 150px);
		}
	}

	.left {
		grid-column: span 6;
		position: relative;
		padding-right: 24px;
		display: flex;
		flex-direction: column;
		row-gap: 24px;

		.top {
			grid-column: span 6;
			display: flex;
			height: 160px;
			padding-top: 50px;

			@media (max-width: $mobile-xl) {
				height: 120px;
				padding-top: 0px;
				padding-bottom: 75px;
				margin: 0 auto;
			}

			h2 {
				color: var(--background-colour);

				@media (max-width: $mobile-xl) {
					text-align: center;
				}
			}
		}

		.nav {
			width: 110px;
			position: relative;
			height: 50px;
		}

		.swiper-text {
			height: auto;
			margin-left: unset;
			margin-right: unset;
			margin-top: 34px;

			.swiper-wrapper-text {
				.swiper-slide {
					flex-direction: column;
					aspect-ratio: unset;
					background: unset;
					justify-content: flex-start;
					align-items: flex-start;
					opacity: 0 !important;

					&.swiper-slide-active {
						opacity: 1 !important;
					}

					h3 {
						color: var(--text-colour);
						font: normal normal medium 20px/24px var(--primary-font-family);
						letter-spacing: 1px;
						text-transform: uppercase;
					}

					p {
						color: var(--text-colour);
						font: normal normal normal 14px/20px var(--primary-font-family);
						text-align: left;
					}
				}
			}
		}
	}

	.right {
		grid-column: span 6;
		overflow: hidden;
		display: flex;
		flex-direction: column;
		row-gap: 40px;

		@media (max-width: $mobile-xl) {
			overflow: unset;
		}

		.swiper-main {
			@media (max-width: $mobile-xl) {
				margin-top: -125px;
			}
		}

		.bottom {
			.nav {
				width: 110px;
				position: relative;
				height: 50px;
			}

			.swiper-text {
				height: auto;
				margin-left: unset;
				margin-right: unset;
				margin-top: 34px;

				.swiper-wrapper-text {
					.swiper-slide {
						flex-direction: column;
						aspect-ratio: unset;
						background: unset;
						justify-content: flex-start;
						align-items: flex-start;
						opacity: 0 !important;

						&.swiper-slide-active {
							opacity: 1 !important;
						}

						h3 {
							color: var(--text-colour);
							font: normal normal medium 20px/24px var(--primary-font-family);
							letter-spacing: 1px;
							text-transform: uppercase;
						}

						p {
							color: var(--text-colour);
							font: normal normal normal 14px/20px var(--primary-font-family);
							text-align: left;
						}
					}
				}
			}
		}

		.swiper-pagination {
			position: relative !important;
			grid-column: span 12;
			display: none;
			justify-content: center;
			gap: 10px;
			left: 0;
			width: 100%;
			bottom: unset !important;
			flex-wrap: wrap;
			z-index: 10;

			@media (max-width: $mobile-xl) {
				gap: 8px;
				display: inline-flex;
				top: -5px !important;
			}

			& > .swiper-pagination-bullet-active {
				background: var(--navy) !important;
			}
		}
	}
}

.swiper-main {
	width: 100%;
	height: 100%;
}

.swiper-slide {
	text-align: center;
	font-size: 18px;
	background: #fff;
	display: flex;
	justify-content: center;
	align-items: center;
	aspect-ratio: 4 / 3;
	/* opacity: 0.3;
	transition: 0.2s ease opacity; */

	img {
		display: block;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.swiper-thumb & {
		aspect-ratio: 178 / 113;
		overflow: hidden;

		img {
			transition: 0.2s ease all;
		}

		&:hover {
			cursor: pointer;

			img {
				transform: scale(1.1);
				transition: 0.2s ease all;
			}
		}
	}

	/* &.swiper-slide-active {
		opacity: 1;
		transition: 0.2s ease opacity;
	}

	&.swiper-slide-next {
		opacity: 0.3;
		transition: 0.2s ease opacity;
	} */
}

.swiper {
	width: 100%;
	height: 300px;
	margin-left: auto;
	margin-right: auto;

	&-main {
		aspect-ratio: 4 / 3;
		height: unset;
	}

	&-thumb {
		height: unset;
	}

	.swiper-slide {
		background-size: cover;
		background-position: center;
	}
}

.mySwiper2 {
	height: 80%;
	width: 100%;
}

.mySwiper {
	height: 20%;
	box-sizing: border-box;
	padding: 10px 0;

	.swiper-slide {
		width: 25%;
		height: 100%;
		opacity: 0.4;

		&.swiper-slide-thumb-active {
			opacity: 1;
		}
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/GalleryModule.vue